import { InjectedConnector } from "@web3-react/injected-connector";

import { NODE_ENV } from "../config";

export default new InjectedConnector({
  supportedChainIds: [NODE_ENV === "dev" ? 4 : 1],
});
